routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.pqrsList', {
      url: __env.routes.pqrsList,
      template: `<pqrs-list sh-ctrl="shCtrl"></pqrs-list>`
    });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/pqrs/pqrs-list/pqrs-list.config.js
 **/